import { render, staticRenderFns } from "./ContentPageList.vue?vue&type=template&id=6ad9bbbb&"
import script from "./ContentPageList.ts?vue&type=script&lang=js&"
export * from "./ContentPageList.ts?vue&type=script&lang=js&"
import style0 from "./ContentPageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports